export function isIE(): boolean {
  const ua: string = window.navigator.userAgent;
  const msie: number = ua.indexOf('MSIE ');
  const trident: number = ua.indexOf('Trident');
  const edge: number = ua.indexOf('Edge');
  return (msie > 0 || trident > 0 || edge > 0);
}

export function isFF(): boolean {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

export function isSafari(): boolean {
  return navigator.userAgent.indexOf('Safari') !== -1 &&
    navigator.userAgent.indexOf('Chrome') === -1;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/common/index.ts